import Vue from 'vue'
import Cookies from 'js-cookie'
import 'normalize.css/normalize.css' // a modern alternative to CSS resets
import Element from 'element-ui'
import './assets/styles/element-variables.scss'
import locale from 'element-ui/lib/locale/lang/en'

import Web3 from 'web3'
Vue.prototype.Web3 = Web3;
try{
  // console.log('ethereum', ethereum)
  window.web3  = new Web3(ethereum);
}catch(e){
  console.log("main.js web3 error",e)
}


import '@/assets/styles/index.scss' // global css
import '@/assets/styles/ruoyi.scss' // ruoyi css
import App from './App'
import store from './store'
import router from './router'
import permission from './directive/permission'

import './assets/icons' // icon
import './permission' // permission control
import { parseTime, resetForm, addDateRange, selectDictLabel, download } from "@/utils/ruoyi";
import { getToken } from "@/utils/auth";
import Pagination from "@/components/Pagination";
import PageTitle from "@/components/PageTitle";
import PageCard from "@/components/PageCard"
import PageBottom from "@/components/PageBottom"
import FileUpload from "@/components/FileUpload";
import LoadingBtn from "@/components/LoadingBtn"
import BigNumber from "@/components/BigNumber"
import SearchDate from "@/components/SearchDate"
import SearchSelect from "@/components/SearchSelect"
import Account from "@/components/Account"
import dict from "@/utils/dict.js"
import '@/assets/iconfont/iconfont.css'
import '@/assets/iconfont/iconfont.js'
import '@/utils/lib-flexible/flexible.js'
import * as BIGNUM from "@/utils/bigNumberTran.js"
import _BigNumber from 'bignumber.js'
import * as filters from "@/utils/filters.js";

Vue.prototype.BigNumber = _BigNumber

if (process.env.VUE_APP_ISMOCK == '1') {    // Judge whether it is mock mode
  require('./mock/index.js')
}

// 全局方法挂载
Vue.prototype.USTNVal = '0x6b2eaf239744cd4b778792605555999cd30bc7cf612ac1235d92c5a818fb4623';
Vue.prototype.UNITVal = '0x08c17eca0e87ee0a14268fdd7a46d674b41ae71d220d9794f7605ab1776c1821';
Vue.prototype.BIGNUM = BIGNUM;
Vue.prototype.getToken = getToken
Vue.prototype.parseTime = parseTime
Vue.prototype.resetForm = resetForm
Vue.prototype.addDateRange = addDateRange
Vue.prototype.selectDictLabel = selectDictLabel
Vue.prototype.download = download
Vue.prototype.dict = dict
Vue.prototype.windowTo = function(url){
  window.open(url);
}

Vue.prototype.moment = require('moment');

Vue.prototype.msgSuccess = function (msg) {
  this.$message({ showClose: true, message: msg, type: "success" });
}
Vue.prototype.msgError = function (msg) {
  this.$message({ showClose: true, message: msg, type: "error" });
}

Vue.prototype.msgInfo = function (msg) {
  this.$message.info(msg);
}

// Global filters
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});

// Global component mount
Vue.component('Pagination', Pagination)
Vue.component('PageTitle', PageTitle)
Vue.component('PageCard', PageCard)
Vue.component('PageBottom', PageBottom)
Vue.component('FileUpload', FileUpload)
Vue.component('LoadingBtn', LoadingBtn)
Vue.component('BigNumber',BigNumber)
Vue.component('SearchDate',SearchDate)
Vue.component('SearchSelect',SearchSelect)
Vue.component('Account',Account)

Vue.use(permission)

/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online! ! !
 */

Vue.use(Element, {
  locale,
  size: Cookies.get('size') || 'medium' // set element-ui default size
})

Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
